import { render, staticRenderFns } from "./ProvideFeedback.vue?vue&type=template&id=26df384d&scoped=true"
import script from "./ProvideFeedback.vue?vue&type=script&lang=js"
export * from "./ProvideFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26df384d",
  null
  
)

export default component.exports